import type { RepairOption, RepairPricePresentation } from '../types';

export type RepairPriceState =
  | { kind: 'FIXED'; amount: number; label: string }
  | { kind: 'FREE'; amount: 0; label: 'Gratuit' }
  | { kind: 'QUOTE'; amount: null; label: 'Sur devis' };

export const resolveRepairPrice = (
  price: RepairOption['price'] | undefined,
  presentation?: RepairPricePresentation,
): RepairPriceState => {
  if (presentation?.contract === 'PUBLIC_REPAIR_PRICE_PRESENTATION_V1') {
    if (presentation.kind === 'QUOTE') return { kind: 'QUOTE', amount: null, label: 'Sur devis' };
    if (presentation.kind === 'FREE') return { kind: 'FREE', amount: 0, label: 'Gratuit' };
    if (presentation.amount !== null && Number.isFinite(presentation.amount) && presentation.amount > 0) {
      return { kind: 'FIXED', amount: presentation.amount, label: presentation.amountLabel };
    }
  }
  const raw = String(price ?? '').trim();
  if (/^(?:free|gratuit)$/iu.test(raw)) return { kind: 'FREE', amount: 0, label: 'Gratuit' };
  if (!raw || /(?:sur\s+devis|devis|quote)/iu.test(raw)) return { kind: 'QUOTE', amount: null, label: 'Sur devis' };
  const normalized = raw.replace(/\s/gu, '').replace(',', '.').replace(/[^\d.-]/gu, '');
  const amount = Number(normalized);
  if (!Number.isFinite(amount) || amount <= 0) return { kind: 'QUOTE', amount: null, label: 'Sur devis' };
  return { kind: 'FIXED', amount, label: raw };
};

export const repairPriceState = (repair: Pick<RepairOption, 'price' | 'pricePresentation'>): RepairPriceState =>
  resolveRepairPrice(repair.price, repair.pricePresentation);

export const presentRepairPrice = (repair: Pick<RepairOption, 'price' | 'pricePresentation'>): string =>
  repairPriceState(repair).label;
